import { Enum } from '../../../platform/Enum';

export const ConnectorMode = Enum({
    direct: 0,
    manhattan: 1,
    smooth: 2,
});

export const ConnectorStrokeStyle = Enum({
    solid: 0,
    dashed: 1,
    dotted: 2,
    cheveron: 3,
});

export const ConnectorCapStyle = Enum({
    none: 0,
    spot: 1,
    solidArrow: 2,
    lineArrow: 3,
});
